import { cloneDeep } from 'lodash'

import { convertRewardToSection } from '../../../views/WheelSpin/components/Statistics/utils'

import { getColumns } from '../../RatingTable/components/RatingData/columns'

export const mapLeadInfo = (leadInfo, blockProjection, rewardsProjection) => {
    const mappedLeadInfo = cloneDeep(leadInfo)

    mappedLeadInfo.fields = blockProjection.metadata.leadFormFields.map(_metaField => {
        const field = mappedLeadInfo.fields.find(_field => _field.key === _metaField.key)
        return { ...field, ..._metaField }
    })

    if (mappedLeadInfo.gamificationData) {
        mappedLeadInfo.gamificationDataArray = getColumns().map(column => ({
            ...column,
            value: mappedLeadInfo.gamificationData[column.field],
        }))
    }

    if (mappedLeadInfo.quizzes) {
        mappedLeadInfo.quizzes = mappedLeadInfo.quizzes.map(quiz => {
            if (blockProjection.blockId === quiz.blockId) {
                const mappedQuiz = cloneDeep(quiz)

                mappedQuiz.quizResults = mappedQuiz.quizResults.map(resultId =>
                    blockProjection.metadata.results.find(resultMeta => resultMeta.id === resultId),
                )
                mappedQuiz.quizAnswers = mappedQuiz.quizAnswers.map(({ questionId, answers }) => {
                    const questionMeta = blockProjection.metadata.questions.find(
                        _questionMeta => _questionMeta.id === questionId,
                    )

                    const mappedAnswers = answers.map(answerId =>
                        questionMeta.answers.find(answerMeta => answerMeta.id === answerId),
                    )

                    return {
                        ...questionMeta,
                        answers: mappedAnswers,
                    }
                })

                return mappedQuiz
            }
            return null
        })
    }

    if (mappedLeadInfo.wheels) {
        mappedLeadInfo.wheels = mappedLeadInfo.wheels.map(wheel => {
            if (blockProjection.blockId === wheel.blockId) {
                const mappedWheel = cloneDeep(wheel)

                mappedWheel.wheelSections = mappedWheel.wheelSections.map(sectionId => {
                    const section = blockProjection.metadata.sections.find(sectionMeta => sectionMeta.id === sectionId)
                    if (section) return section
                    else {
                        if (rewardsProjection) {
                            const reward = rewardsProjection.list.find(reward => reward.id === sectionId)
                            if (reward) return convertRewardToSection(reward)
                        }
                    }
                })

                return mappedWheel
            }
            return null
        })
    }

    return mappedLeadInfo
}
